var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"fj-main"},[_c('nuxt',{attrs:{"nuxt-child-key":_vm.fullRouteName}}),_vm._v(" "),_c('BackTop',{attrs:{"bottom":100,"right":30}},[_c('div',{staticClass:"back-top return-to-top-btn"},[_c('i',{staticClass:"triangle-icon triangle-icon-000 p-a c-c d-b"})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }